import { LengthUnit } from "@colibrio/colibrio-reader-framework/colibrio-core-base";
import { EpubRemoteResourcePolicyType  } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub";
import type { IReaderViewOptions } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import type {IEpubReaderPublicationOptions } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub";

export const CirrusReaderDefaultColibrioEpubReaderPublicationOptions: IEpubReaderPublicationOptions = {
    // Media will be streamed from the EPUB file when possible. This is currently supported for constant bitrate
    // MP3 audio that has been added to the EPUB using the ZIP "store" method.
    enableMediaStreaming: true,
    // Prevent users from right-clicking and downloading images and video etc.
    preventDefaultContextMenuOnMediaElements: true,
    // Reflow is the Colibrio module that paginates reflowable EPUBs. It is highly configurable. In the options
    // below we tell Reflow that it is ok to divide HTML elements as a default, except for the black listed
    // selectors specified.
    reflowOptions: {
        plugins: {
            fragmentableElements: {
                allowByDefault: true,
                blacklistSelectors: [
                    'details',
                    'figure',
                    'mathml'
                ],
            },
            mediaShrink: {
                activationThreshold: .15,
                maxShrinkFactor: .7,
                penaltyAtMaxShrinkage: 10
            }
        },
    },
    // Sometimes you will want to override certain CSS in one or more publication. The following options
    // injects a CSS rule that "turns off" the focus marker *before* any of the publications own CSS, and
    // also injects CSS rules *after* the publications own CSS, thus overriding it.
    customPublicationCss: {
        enableNormalizeCss: false,
        injectionPointStart: [
            ':focus-visible {outline: none;}',
            'a:focus-visible {outline: initial;}',
        ],
        injectionPointEnd: [
            'col:empty {display: none;}',
            'details, figure {page-break-inside: avoid;}',
            'details[open] {height: auto; overflow-y: scroll; background-color: Canvas; }',
            'svg {text-rendering: optimizespeed; shape-rendering: optimizespeed; will-change: contents}'
        ],
    },
    remoteResourcesNonScriptedDocumentsOptions: {
        policyType: EpubRemoteResourcePolicyType.ALLOW_ALL
    },
    remoteResourcesScriptedDocumentsOptions: {
        policyType: EpubRemoteResourcePolicyType.ALLOW_ALL
    },
    contentBlockOptions: {
        disableDefaultAttributeFiltering: true,
        includePreContentBlocks: true,
        includeMathMlContentBlocks: true
    }
};

export const CirrusReaderDefaultColibrioReaderViewOptions: IReaderViewOptions = {
    transformManagerOptions: {
        removeTransformOnNavigation: false,
        maxPanOffsetHorizontal: {
            unit: LengthUnit.PERCENT,
            value: 50
        },
        maxPanOffsetVertical: {
            unit: LengthUnit.PERCENT,
            value: 50
        }
    },
    gestureOptions: {
        panZoom: {
            allowSinglePointerPan: true,
            pointerTypes: {
                pen: true,
                mouse: true,
                touch: true
            }
        }
    },
    emitPointerMoveEventsOnHover: true,
};
